import React from 'react';
import CommissionRatesView from 'tailwind-components/Commissions/CommissionRatesView';
import { useParams } from 'react-router-dom';
import BonusView from 'tailwind-components/Commissions/BonusView';
import StatementsView from './StatementsView/StatementsView';
import BookOfBusiness from './BookOfBusiness/BookOfBusiness';

function Commissions() {
  const { type } = useParams();

  if (type === 'rates') return <CommissionRatesView />;
  if (type === 'statements') return <StatementsView />;
  if (type === 'book-of-business') return <BookOfBusiness />;
  return <BonusView />;
}

export default Commissions;
